var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAgoraLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_23820",
    "data-name": "Grupo 23820",
    transform: "translate(-974 -3015)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_4444",
    "data-name": "Ret\\xE2ngulo 4444",
    width: 70,
    height: 70,
    rx: 10,
    transform: "translate(974 3015)",
    fill: "#fcfcfc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3647",
    "data-name": "Caminho 3647",
    d: "M57.1,105.756H52L39.338,136.093h4.9l3.128-7.34,14.348-.006,3.143,7.355h4.9Zm-9.733,22.992,7.181-16.856v.007l7.167,16.854Z",
    transform: "translate(954.662 2929.244)",
    fill: "#01c592",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgoraLogo);
export default __webpack_public_path__ + "static/media/agora-logo.1b866cdc281e2157a09afdece7bebad8.svg";
export { ForwardRef as ReactComponent };